module.exports = __webpack_public_path__ + "7040bf43e5b067ab1f0e5972b19c6be8.pdf";